
export const FeatureFlagActionType = {
  SET_FLAGS: "SET_FLAGS"
}
